import React, { Component } from 'react'
import _ from 'lodash'
import { AppInsights } from 'applicationinsights-js';
import PhoneNumber from '../../felles/utils/PhoneNumber';

import { ButtonToolbar } from 'react-bootstrap'
import moment from 'moment'

import ReactTable from '@norkart/react-table'
import NkModal from '../../felles/Dialogs/NKModal.jsx'
import NkaButton from 'nka-button'
import KartModal from '../../felles/Kart/kartContainer.jsx'
import { resolve } from '../../dependencies'
import Repository from '../../felles/repository'

import SendVarselModal from './sendvarselModal'

import ContextMenu from '../../felles/ContextMenu'
import InfoFraKundeModal from './infofraKundeModal'
import FlyttVannmaalerModal from './flyttVannmaalerModal'
import EndreTidspunkt from './endreTidspunktModal'

import { datoFormatMedTidspunktTekst } from '../../felles/utils/dato-format-tabell'
import {Maalerstatus} from '../../felles/utils/statuskoder'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import '@norkart/react-table/dist/react-table.css'
import 'nka-button/dist/style.css'
import './arbeidsliste.css'

moment.locale('nb')

export default class ArbeidslisteItemAktiv extends Component {
    constructor(props) {
        super(props)

        this.state = {
            nyeMaalere: [],
            isLeggtilVannmaalerModalOpen: false,
            isSendVarselModalOpen: false,
            isKartModalOpen: false,
            isKalenderModalOpen: false,
            isInfoKundeModalOpen: false,
            isFlyttVannmaalerModalOpen: false,
            isIEndreTipdspunktModalOpen: false,
            valgVannmalerId: 0,
            adresse: null,
            kommentar: '',
            avtaltDato: null
        }

        this._closeLeggtilVannmaalerModal = this._closeLeggtilVannmaalerModal.bind(this)
        this._onOpenNyMaalerModal = this._onOpenNyMaalerModal.bind(this)
        this._oppdaterArbeidsliste = this._oppdaterArbeidsliste.bind(this)
        this._onClickFjernVannmaaler = this._onClickFjernVannmaaler.bind(this)
        this._onClickFlyttVannmaalerModal = this._onClickFlyttVannmaalerModal.bind(this)
        this._onOpenSendVarselModal = this._onOpenSendVarselModal.bind(this)
        this._closeSendVarselModal = this._closeSendVarselModal.bind(this)
        this._sendVarsel = this._sendVarsel.bind(this)
        this._onOpenKartModal = this._onOpenKartModal.bind(this)
        this._closeKartModal = this._closeKartModal.bind(this)
        this._onOpenKalenderModal = this._onOpenKalenderModal.bind(this)
        this._closeKalenderModal = this._closeKalenderModal.bind(this)
        this._onClickOppdaterVannmaalerAvtalt = this._onClickOppdaterVannmaalerAvtalt.bind(this)
        this._onClickOpenInfofraKundeModal = this._onClickOpenInfofraKundeModal.bind(this)
        this._closeInfofraKundeModal = this._closeInfofraKundeModal.bind(this)
        this._leggTilInfoFraKunde = this._leggTilInfoFraKunde.bind(this)
        this._onClickOpenEndreTidspunktModal = this._onClickOpenEndreTidspunktModal.bind(this)
        this._closeEndreTidspunktModal = this._closeEndreTidspunktModal.bind(this)
        this._endreTidspunt = this._endreTidspunt.bind(this)
        this._aktiverArbeidsliste = this._aktiverArbeidsliste.bind(this)
        this._deaktiverArbeidsliste = this._deaktiverArbeidsliste.bind(this)
        this._opprettTempArbeilisteObjekt = this._opprettTempArbeilisteObjekt.bind(this)
        this._endreArbeidslisteId = this._endreArbeidslisteId.bind(this)
        this._onClick1881 = this._onClick1881.bind(this)
    }

    _onClickFjernVannmaaler(maalerId) {
        this.props.fjernMaalerFraListe(maalerId)
    }

    _onClickOppdaterVannmaalerAvtalt(maaler) {
        this.props.oppdaterVannmaalerAvtalt(maaler)
    }

    _onClick1881(maaler){
        
        resolve(Repository).hentPoststedForVannmaaler(maaler.VmPid).then(poststed => {            
            var query = maaler.Maalepunktadresse + ' ' + maaler.Husnummer +  
            ((maaler.Husbokstav && maaler.Husbokstav.length > 0  && maaler.Husbokstav.trim()) ? ' ' + maaler.Husbokstav : '') 
            + (poststed ? (', ' + poststed) : '');
            var url = 'https://www.1881.no/?Query=' + query
            window.open(url);
        })
    }

    getColumns() {
        return [
            {
                id: 'Maalepunktadresse',
                name: 'Adresse',
                isSorted: false,
                formatter: function (maaler) {
                    return  maaler.Maalepunktadresse +' '+ maaler.Husnummer +" "+ (maaler.Husbokstav ? maaler.Husbokstav: '')
                }
            },
            {
                id: 'Avlesertype',
                name: 'Avlesertype',
                isSorted: false,
                sortable: false
            },
            {
                id: 'Mobil',
                name: 'Mobilnummer',
                isSorted: false,
                sortable: false,
                formatter: function (maaler) {
                    return <PhoneNumber number={maaler.Mobil} />
                }
            },
            {
                id: 'Telefon',
                name: 'Telefon',
                isSorted: false,
                sortable: false,
                formatter: function (maaler) {
                    return <PhoneNumber number={maaler.Telefon} />
                }
            },
            {
                id: 'Avtaltdato',
                name: 'Avtaltdato',
                isSorted: false,
                sortable: false,
                formatter: function (maaler) {
                    return datoFormatMedTidspunktTekst(maaler.Avtaltdato)
                }
            },
            {
                id: 'Status',
                name: 'Status',
                isSorted: false,
                sortable: false,
                formatter: function (maaler) {
                    
                    if (maaler.Status === Maalerstatus.Ny)
                        return ''
                    if (maaler.Status === Maalerstatus.Varslet)
                        return 'Varslet'
                    if (maaler.Status === Maalerstatus.Avtalt)
                    {                        
                        
                        if(maaler.SmsStatus){
                            var regEx = new RegExp('\\b' + 'ok' + '\\b|\\b' + 'ja' + '\\b');
                            var found =  regEx.test(maaler.SmsStatus.toLowerCase());

                            if (found)                        
                                return 'Avtalt'
                            else
                                return 'Avvist'
                        }else{
                            return 'Avtalt'
                        }                        
                    }
                        
                    if (maaler.Status === Maalerstatus.Skiftet)
                        return 'Skiftet'
                    if (maaler.Status === Maalerstatus.IkkeSkiftet)
                        return 'Ikke skiftet'
                }
            }
            ,
            {
                id: 'SmsLevertStatus',
                name: this.props.lasterSms
                    ? <span>Smsstatus <span className="sms-kolonne-spinner" /></span>
                    : 'Smsstatus',
                isSorted: false,
                sortable: false
            }
            ,
            {
                id: 'SmsStatus',
                name: this.props.lasterSms
                    ? <span>Svar <span className="sms-kolonne-spinner" /></span>
                    : 'Svar',
                isSorted: false,
                sortable: false
            },            
            {
                id: 'Meny',
                sortable: false,
                formatter: function (maaler) {                                        
                        return (
                            <ContextMenu.Button title="Meny" icon="meny" iconColor="nk-black" className="inlinebtn">                                
                                <ContextMenu.Item eventKey={maaler} onSelect={this._onClickOppdaterVannmaalerAvtalt}>Avtalt</ContextMenu.Item>
                                <ContextMenu.Item eventKey={maaler} onSelect={this._onClick1881}>Oppslag 1881</ContextMenu.Item>
                                <ContextMenu.Divider></ContextMenu.Divider>
                                <ContextMenu.Item eventKey={maaler} onSelect={this._onClickOpenEndreTidspunktModal}>Endre tidspunkt...</ContextMenu.Item>
                                <ContextMenu.Item eventKey={maaler} onSelect={this._onClickOpenInfofraKundeModal}>Info fra kunde...</ContextMenu.Item>
                                <ContextMenu.Item eventKey={maaler} onSelect={this._onClickFlyttVannmaalerModal}>Flytt...</ContextMenu.Item>                                                                                            
                                <ContextMenu.Divider></ContextMenu.Divider>
                                <ContextMenu.Item eventKey={maaler.MaalerId} onSelect={this._onClickFjernVannmaaler}>Fjern</ContextMenu.Item>
                            </ContextMenu.Button>
                        )
                }.bind(this)
            }
        ];
    };

    _onClickOpenInfofraKundeModal(maalerfraGrid) {
        this.setState({
            isInfoKundeModalOpen: true,
            valgVannmalerId: maalerfraGrid.MaalerId,
            kommentar: maalerfraGrid.Kommentar
        })
    }

    _closeInfofraKundeModal() {
        this.setState({
            isInfoKundeModalOpen: false
        })
    }

    _onClickFlyttVannmaalerModal(maaler) {        
        this.setState({
            isFlyttVannmaalerModalOpen: true,
            valgVannmalerId: maaler.MaalerId,
            adresse: maaler.Maalepunktadresse+' '+maaler.Husnummer +" "+ (maaler.Husbokstav ? maaler.Husbokstav: '')
        })
    }


    _onOpenKartModal() {
        this.setState({
            isKartModalOpen: true
        })
    }

    _closeKartModal() {
        this.setState({
            isKartModalOpen: false
        })
    }

    _onOpenKalenderModal() {
        this.setState({
            isKalenderModalOpen: true
        })
    }

    _closeKalenderModal() {
        this.setState({
            isKalenderModalOpen: false
        })
    }

    _onOpenNyMaalerModal() {
        if(this.props.status === 1){
            alert('Kan ikke legge til vannmålere på en aktiv liste')
            return
        }
        this.setState({
            isLeggtilVannmaalerModalOpen: true
        })
    }

    _closeLeggtilVannmaalerModal() {
        this.setState({
            isLeggtilVannmaalerModalOpen: false
        })
    }

    _onOpenSendVarselModal() {
        this.setState({
            isSendVarselModalOpen: true
        })
    }

    _closeSendVarselModal() {
        this.setState({
            isSendVarselModalOpen: false
        })
    }

    _onClickOpenEndreTidspunktModal(maaler) {
        this.setState({
            isIEndreTipdspunktModalOpen: true,
            valgVannmalerId: maaler.MaalerId,
            avtaltDato: maaler.Avtaltdato
        })        
    }

    _closeEndreTidspunktModal() {
        this.setState({
            isIEndreTipdspunktModalOpen: false
        })
    }

    _sendVarsel(tekst) {
        let varsel = {
            Tekst: tekst,
            ArbeidslisteId: this.props.id
        }

        this.setState({
            isSendVarselModalOpen: false
        })

        this.props.sendVarsel(varsel)
    }

    _oppdaterArbeidsliste() {
        this.setState({
            isLeggtilVannmaalerModalOpen: false
        })

        var nyeVannmaalerIder = _.flattenDeep(this.state.nyeMaalere)

        nyeVannmaalerIder = _.uniq(nyeVannmaalerIder)

        this.props.vannmaalerIder.map(id => nyeVannmaalerIder.push(id))

        let arbeidsListe = {
            Id: this.props.id,
            Tittel: this.props.tittel,
            Beskrivelse: this.props.beskrivelse,
            Vannmaalere: nyeVannmaalerIder,
            Startdato: this.props.startdato,
            StartTidspunkt: this.props.startTidspunkt,
            SluttTidspunkt: this.props.sluttTidspunkt,
            Status: this.props.status
        } 
        
        this.props.oppdateArbeidsliste(arbeidsListe)
    }

    _leggTilInfoFraKunde(info) {
        this.props.leggTilInfoFraKunde(info, this.state.valgVannmalerId)
        this.setState({
            isInfoKundeModalOpen: false
        })
    }

    _endreTidspunt(nyTid,oppdaterTidspukter) {
        this.props.endreAvtaltTidspunt(nyTid, this.state.valgVannmalerId, oppdaterTidspukter)
        this.setState({
            isIEndreTipdspunktModalOpen: false
        })
    }

    _endreArbeidslisteId(nyListeId){
        this.props.endreListeIdPaaMaaler(nyListeId, this.state.valgVannmalerId)
        this.setState({
            isFlyttVannmaalerModalOpen: false
        })
    }

     _opprettTempArbeilisteObjekt(){
        let arbeidsListe = {
            Id: this.props.id,
            Tittel: this.props.tittel,
            Beskrivelse: this.props.beskrivelse,
            Startdato: this.props.startdato,
            Status: this.props.status,
            StartTidspunkt: this.props.startTidspunkt,
            SluttTidspunkt: this.props.sluttTidspunkt
        }
        
        return arbeidsListe;
    }

    _aktiverArbeidsliste() {        
        let arbeidsListe = this._opprettTempArbeilisteObjekt()
        arbeidsListe.Status = 1
        this.props.oppdateArbeidsliste(arbeidsListe)
    }  

    _deaktiverArbeidsliste() {       
        let arbeidsListe = this._opprettTempArbeilisteObjekt()
        arbeidsListe.Status = 0
        this.props.oppdateArbeidsliste(arbeidsListe)
    }

    render() {
        AppInsights.trackPageView(null, null, { measurement1: 1 }, 123);
        let kolonner = this.getColumns();

        return (
            <div className="listeContainer">
                <h2>{this.props.tittel}</h2>
                <p>Beskrivelse: {this.props.beskrivelse}</p>

                <ButtonToolbar>
                    

                    <NkaButton icon="pluss" onClick={() => this.props.redigerListe && this.props.redigerListe()} >
                        Legg til
                    </NkaButton>

                    <NkaButton icon="kommentar" onClick={this._onOpenSendVarselModal}>
                        Send SMS
                    </NkaButton>

                    <NkaButton icon="lokasjon" onClick={this._onOpenKartModal}>
                        Vis i kart
                    </NkaButton>

                    {this.props.status === 0
                        ?
                        <NkaButton icon="lasting" onClick={this._aktiverArbeidsliste} >
                            Aktiver
                    </NkaButton>
                        :
                        <NkaButton icon="lasting" onClick={this._deaktiverArbeidsliste} >
                            Deaktiver
                    </NkaButton>
                    }


                </ButtonToolbar>
                <br />

              
                 
              
                <div className="maalere">
                    <ReactTable
                        items={this.props.vannmaalere}
                        idProperty='MaalerId'
                        showIndex={false}
                        filterable={false}
                        itemsPrPage={20}
                        columns={kolonner}
                        selectableRows={false}
                        onRowClick={null}
                    />
                </div>
              
               
                <NkModal size='large' isOpen={this.state.isKartModalOpen}>
                    <KartModal id={this.props.id} onClose={this._closeKartModal} skalviseMaalerskfteKnapp={false} />
                </NkModal>
              
                <SendVarselModal isOpen={this.state.isSendVarselModalOpen} onClose={this._closeSendVarselModal} onSendVarsel={this._sendVarsel} />
                <FlyttVannmaalerModal isOpen={this.state.isFlyttVannmaalerModalOpen} adresse={this.state.adresse} onClose={() => this.setState({isFlyttVannmaalerModalOpen: false})} onFlytt={this._endreArbeidslisteId} />


                {this.state.isInfoKundeModalOpen &&
                    <InfoFraKundeModal isOpen={this.state.isInfoKundeModalOpen} onClose={this._closeInfofraKundeModal} onLeggTilInfo={this._leggTilInfoFraKunde}
                        kommentar={this.state.kommentar}
                    />
                }
                <EndreTidspunkt isOpen={this.state.isIEndreTipdspunktModalOpen} onClose={this._closeEndreTidspunktModal}
                    avtaltdato={this.state.avtaltDato} onEndreTidspunt={this._endreTidspunt} />

            </div>
            
        )
    }
}




// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/arbeidsliste.jsx